module.exports = __webpack_public_path__ + "static/labri-logo-860642a48af4ba77a56ec85c76592522.png";